import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { ProductsOrder } from "./ProductsComponents";
import Pagination from "../Pagination";
import { useTranslation } from "react-i18next";
import Global from "../../util/Global";
import { useNavigate } from "react-router-dom";
import { Rating } from "@mui/material";
import { LoaderComponent } from "../../util/Loader";
import NotFound from "../NotFound";
import { CurrencyContext } from "../Utils";
import { GlobalData } from "../../util/GlobalData";

export default function ProductsComponent({ itemsPerPage, items, UserStyle = false }) {
  const [orderedItems, setOrderedItems] = useState([])
  const [paginatedItems, setPaginatedItems] = useState([])
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isLoading, setisLoading] = useState(true)
  const userId = localStorage.getItem("id")
  const { currency, getCurrencyPrice } = useContext(CurrencyContext)

  const [ratingList, setratingList] = useState([])
  const AVIS_URL = Global.backend + "/index.php/avis/avisofproduct";






  useEffect(() => {
    if (!UserStyle) {
      setisLoading(false)
      return
    }
    if (!items.length || !isLoading) {
      return
    }



    items.forEach(product => {
      let moy = 0;
      product.avis.map(avis => moy += avis.etoile_nb)


      setratingList(prev => [
        ...prev,
        {
          produitId: product.id,
          moy: moy / product.avis.length,
          count: product.avis.length
        }
      ])
    })

    setisLoading(false)


  }, [items])


  const GuestStyleComponent = () => {
    return (
      <>
        {paginatedItems.map((product, index) => {
          return (
            <div className="col-md-4" key={index}>
              <div
                className="front-card card h-90 shadow-lg mb-5"
              >
                <div style={{ height: 200 }}>
                  <img
                    src={product.image[0]?.imageURL ? `${Global.backend}/uploads/${product.image[0].imageURL}` : require("../../assets/img/default_product.png")}
                    className="card-img-top"
                    alt="..."
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>

                <>
                  {product.stock > 0 ? (
                    <div className="label-top shadow-sm">
                      {t("inStock")}
                    </div>
                  ) : (
                    <div
                      className="label-top shadow-sm"
                      style={{ backgroundColor: "red" }}
                    >
                      {t("outOfStock")}
                    </div>
                  )}
                </>

                <div className="card-body">
                  <div
                    className=" mb-3"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    {product.discount ? (
                      <span
                        className="float-start badge rounded-pill bg-success"
                        style={{ color: "white" }}
                      >
                        {GlobalData.currency[currency]}{getCurrencyPrice((product.prix - (product.prix * product.discount / 100)), product.currency)}
                      </span>
                    ) : (
                      <span
                        className="float-start badge rounded-pill bg-success"
                        style={{ color: "white" }}
                      >
                        {GlobalData.currency[currency]}{getCurrencyPrice(product.prix, product.currency)}
                      </span>
                    )}

                    {product.discount && (
                      <span className="float-end">
                        <span
                          style={{
                            backgroundColor: "red",
                            color: "white",
                            padding: 2,
                            borderRadius: 5,
                            fontWeight: "bold",
                          }}
                        >
                          -{product.discount}%
                        </span>
                        &nbsp;&nbsp;
                        <a className="text-muted">
                          <span
                            style={{
                              textDecoration: "line-through",
                            }}
                          >
                            {GlobalData.currency[currency]}{getCurrencyPrice(product.prix, product.currency)}
                          </span>
                        </a>
                      </span>
                    )}
                  </div>



                  <div className="d-flex align-items-center">
                    <h5 className="card-title h-100" style={{
                      textWrap: "nowrap",
                      textOverflow: "ellipsis",
                      margin:0
                    }}>
                      {product.nom || "Honey"}
                    </h5>
                    {product.user.id == userId && <h6 className="text-primary h-100" style={{
                      textWrap: "nowrap",
                      textOverflow: "ellipsis"
                    }}>({t("yourProduct")})</h6>}
                  </div>


                  <p style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                  }}>
                    {product.description || "Honey..."}
                  </p>



                  <div className="text-center my-2">
                    <button
                      className="btn-lg rounded-pill"
                      style={{
                        backgroundColor: "#3f2414",
                        color: "white",
                      }}
                      onClick={() => {
                        navigate("/detailproduit/" + product.id);
                      }}
                    >
                      <>{t('catalog2.1')}</>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )
        })}

      </>
    )
  }


  const UserStyleComponent = () => {
    return (
      <>
        {paginatedItems.map((product, index) => {
          return (
            <div className="col-md-4" key={index} >
              <div
                className="front-card card h-90 shadow-lg mb-5"
              >
                <div className="product-img">
                  {product.discount != null && product.discount != 0 && (
                    <div
                      className="product-ribbon  bg-primary"
                      style={{ margin: 10 }}
                    >
                      <span
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {product.discount}%
                        <br />
                      </span>
                      Off
                    </div>
                  )}
                  <img
                    src={product.image[0]?.imageURL ? `${Global.backend}/uploads/${product.image[0].imageURL}` : require("../../assets/img/default_product.png")}
                    alt=""
                    className="img-fluid mx-auto d-block"
                    style={{
                      height: 180,
                      borderTopLeftRadius: 15,
                      borderTopRightRadius: 15,
                      marginBottom: 20,
                    }}
                  />
                </div>

                <div className="text-center">
                  <h4 style={{ fontWeight: "normal" }} className="mb-1">
                    {product.nom || "Honey"}
                  </h4>

                  {product.discount != null && product.discount != 0 ? (
                    <h4 className="mb-3">
                      {GlobalData.currency[currency]}{getCurrencyPrice(product.prix - (product.prix * product.discount / 100), product.currency)}
                      <span className="font-size-14 text-muted me-2">
                        <del>{GlobalData.currency[currency]}{product.prix}</del>
                      </span>
                    </h4>
                  ) : (
                    <h4 className="mb-3">{GlobalData.currency[currency]}{getCurrencyPrice(product.prix, product.currency)}</h4>
                  )
                  }



                  <div>
                    <Rating
                      name="half-rating-read"
                      value={ratingList.find(rate => rate.produitId === product.id)?.moy || 0}
                      precision={0.5}
                      readOnly
                    />
                  </div>

                  <p>
                    ({ratingList.find(rate => rate.produitId === product.id)?.count || 0} {t("customerreviews")})
                  </p>
                </div>

                <div className="text-center my-2">
                  <button
                    className="btn-lg rounded-pill"
                    style={{
                      backgroundColor: "#3f2414",
                      color: "white",
                    }}
                    onClick={() => {
                      navigate("/dashboard/user/myproduct/" + product.id);
                    }}
                  >
                    <>{t('catalog2.1')}</>
                  </button>
                </div>
              </div>

            </div>
          )
        })}
      </>
    )
  }

  return (
    <LoaderComponent isLoading={isLoading}>
      {!items.length ? <NotFound /> :
        <div className="container-fluid">
          <div className="row">


            <ProductsOrder items={items} setOrderedItems={setOrderedItems} />


            {UserStyle ? <UserStyleComponent /> : <GuestStyleComponent />}

          </div>



          <Pagination itemsPerPage={itemsPerPage} items={orderedItems} setItems={setPaginatedItems} />
        </div>
      }
    </LoaderComponent>
  );
}














